<template>
  <div class="row">
    <b-col><NumberSeprator v-model="number"></NumberSeprator></b-col>
    <b-col>{{ number }}</b-col>
  </div>
</template>
<script>
import NumberSeprator from "../../components/numberSeprator";
export default {
  name: "numbersepratortest",
  data() {
    return {
      number: 0,
    };
  },
  components: {
    NumberSeprator,
  },
};
</script>